<mat-horizontal-stepper
	#stepper
	class="obg-flow-stepper"
	[ngClass]="{ 'obg-flow-without-header': hideStepperHeader }"
	[linear]="linear"
	[selectedIndex]="startIndex"
	obgAnimateDialogHeightResize
	[containerElement]="stepperContainer"
	[height]="
		stepsComponentConfiguration && stepsComponentConfiguration[stepper.selectedIndex + stepperIndex]
			? stepsComponentConfiguration[stepper.selectedIndex + stepperIndex]?.stepHeight
			: undefined
	"
	[extraHeight]="extraHeightForResizeAnimation"
	(animationStart)="heightChangeAnimationStart.emit()"
	(animationDone)="heightChangeAnimationDone.emit()"
	test-id="sequential-flow-stepper"
	[disableRipple]="true"
>
	<mat-step *ngIf="showPlaceholderStep" [completed]="true" [editable]="false">
		<ng-template matStepLabel>{{ placeholderStepLabel }}</ng-template>
	</mat-step>
	<mat-step *ngFor="let step of flowSteps; let index = index">
		<ng-template matStepLabel>{{ step.name }}</ng-template>
		<ng-container *ngIf="!loading" [ngSwitch]="step.name">
			<ng-container *ngIf="stepsComponentConfiguration[stepper.selectedIndex + stepperIndex]">
				<obg-lazy-loader
					*ngIf="
						stepsComponentConfiguration[stepper.selectedIndex + stepperIndex].lazyItem &&
						index === stepper.selectedIndex + stepperIndex
					"
					[lazyItem]="stepsComponentConfiguration[stepper.selectedIndex + stepperIndex].lazyItem"
				>
				</obg-lazy-loader>
				<obg-login-flow-step-renderer
					*ngIf="
						!stepsComponentConfiguration[stepper.selectedIndex + stepperIndex].lazyItem &&
						index === stepper.selectedIndex + stepperIndex
					"
					[item]="stepsComponentConfiguration[stepper.selectedIndex + stepperIndex]"
					(navigate)="goToNextStep()"
				>
				</obg-login-flow-step-renderer>
			</ng-container>
		</ng-container>
		<ng-container *ngIf="loading">
			<div class="obg-flow-loader">
				<mat-spinner diameter="30"></mat-spinner>
			</div>
		</ng-container>
	</mat-step>
	<ng-template matStepperIcon="edit">
		<mat-icon matSuffix class="ico-checkmark step-icon"></mat-icon>
	</ng-template>
	<ng-template matStepperIcon="done">
		<mat-icon matSuffix class="ico-checkmark step-icon"></mat-icon>
	</ng-template>
	<ng-template matStepperIcon="number" let-index="index">
		<mat-icon class="step-icon" [class.step-icon-not-active]="stepper.selectedIndex !== index">{{
			index + 1
		}}</mat-icon>
	</ng-template>
</mat-horizontal-stepper>
